import { applyEventCallback } from './utility/abtest';

function eventCallback(value) {
  // implement ab test here according to value
}

export default function applyAbTesting() {
    applyEventCallback(eventCallback);
}